import BigNumber from "bignumber.js";
import { ethers } from "ethers";

function convertBalance(balance) {
    const bnBalance = new BigNumber(balance.toString());
    const divisor = (new BigNumber(10)).pow(18);
    return prettifyNumber(bnBalance.div(divisor).toFixed(2));
}

function splitDescription(description) {
    const splittedDesc = description.replaceAll("%25", "%").split('%0A');
    const title = splittedDesc[0];
    const otherSlice = splittedDesc.slice(1).reverse();
    const other = otherSlice.reduce((val, acc) => acc + "\n" + val, "");
    return {title, other};
}

function encodeParameters(types, values) {
    const abi = new ethers.utils.AbiCoder();
    return abi.encode(types, values);
}

function address(n) {
    return `0x${n.toString(16).padStart(40, '0')}`;
}

function prettifyNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export {convertBalance, splitDescription, encodeParameters, address, prettifyNumber};